const currencyFormatter = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const PaymentGridHeader = [
  {
    field: "rowNumber",
    headerName: "#",
    minWidth: 70,
    flex: 0.45,
    sortable: false,
    filterable: false,
  },
  {
    field: "InvoiceNr",
    headerName: "Numri i Pagesës",
    minWidth: 170,
    flex: 1,
    sortable: true,
    filterable: true,
  },
  {
    field: "Date",
    headerName: "Data",
    minWidth: 140,
    flex: 0.9,
    sortable: true,
    filterable: true,
  },
  {
    field: "AccountName",
    headerName: "Furnitori",
    minWidth: 260,
    flex: 1.7,
    sortable: true,
    filterable: true,
  },
  {
    field: "LedgerName",
    headerName: "Llogaria",
    minWidth: 120,
    flex: 0.8,
    sortable: true,
    filterable: true,
  },
  {
    field: "Total",
    headerName: "Vlera",
    minWidth: 140,
    flex: 0.9,
    sortable: true,
    filterable: true,
    valueFormatter: (value) => currencyFormatter.format(Number(value || 0)),
  },
];
